/**************************************************
 * Nombre:       Tarjeta_Bienvenido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../Recursos/frase.png'
import {COLORTEXTO} from "../../Constantes";
import Boton from "../Secciones/Componentes/SubComponentes/Boton";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useIrRuta} from "../../Utilidades/useIrRuta";

const Tarjeta_Bienvenido = () => {
    const {sCell} = useResponsive()
    const {Aviso, abrirAviso} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: 'white',
                backgroundImage: sCell ? 'linear-gradient(180deg, #FFF 0%, #FFF 100%)' : 'linear-gradient(85deg, rgba(255, 255, 255, 0.40) 5.54%, rgba(255, 255, 255, 0.00) 98.12%), url(' + fondo + ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                p: sCell ? 2 : 10,
                borderRadius: 6
            }}
        >

            <Aviso/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{
                        backgroundColor: '#ffffff',
                        borderRadius: 2,
                        px: 2,
                        color: COLORTEXTO,
                        fontWeight: 600,
                        textAlign: 'center',
                        fontSize: 14,
                        pt: 0.7,
                        pb: 0.5
                    }}>Medico Mauricio Nicolás Battafarano</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography
                    sx={{
                        color: COLORTEXTO,
                        fontWeight: 600,
                        textAlign: sCell ? 'center' : 'left',
                        fontSize: sCell ? 24 : 32,
                        lineHeight: 1.2
                    }}>
                    "La incertidumbre nos hace sentir como un barco a la deriva, pero la logoterapia nos recuerda que,
                    aunque no controlamos el viento ni la marea, siempre somos los capitanes de nuestra propia actitud."
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 6}}>
                <Boton click={() => abrirAviso('Citas aun no disponibles')} texto={'Agenda tu Cita'}/>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Bienvenido    